import CurrencyFormat from 'react-currency-format'
import PropTypes from 'prop-types'
import React from 'react'

const Currency = ({amount}) => {
  if (amount == null) {
    return null
  }

  return (
    <CurrencyFormat
      value={amount}
      displayType="text"
      thousandSeparator={true}
      decimalScale={2}
      fixedDecimalScale={true}
      prefix={'$'}
    />
  )
}

Currency.propTypes = {
  amount: PropTypes.number
}

export default Currency
